import { produce } from 'immer'
import {
  SET_HIDE_TOAST,
  SET_IS_TOAST_OPEN,
  SET_UNHIDE_TOAST,
  ToastActions,
} from 'src/app/Toast/redux/toast.actions'
import { HidableToastNames } from 'src/enums'

export interface ToastBaseState {
  isToastOpen: boolean
  toastMessage?: React.ReactElement
  inProgressColorScheme?: boolean
  failureColorScheme?: boolean
  partialSuccessColorScheme?: boolean
  hideImage?: boolean
  image?: React.ReactElement
  isInfinite?: boolean
  isDarkBackground?: boolean
  forceHideToast?: boolean
  hidableToastName?: HidableToastNames
  hiddenToasts: HidableToastNames[]
  bulkToast?: boolean
}

export const initialBaseState: ToastBaseState = {
  isToastOpen: false,
  isInfinite: false,
  forceHideToast: false,
  hiddenToasts: [],
  bulkToast: false,
}

export type BaseActions = ToastActions

const ToastReducer = (
  state = initialBaseState,
  action: BaseActions,
): ToastBaseState => {
  return produce(state, (draft) => {
    switch (action.type) {
      case SET_IS_TOAST_OPEN: {
        draft.isToastOpen = action.payload.isToastOpen
        draft.toastMessage = action.payload.toastMessage
        draft.hidableToastName = action.payload.hidableToastName
        draft.inProgressColorScheme = action.payload.inProgressColorScheme
        draft.failureColorScheme = action.payload.failureColorScheme
        draft.partialSuccessColorScheme =
          action.payload.partialSuccessColorScheme
        draft.hideImage = action.payload.hideImage
        draft.image = action.payload.image
        draft.isInfinite = action.payload.isInfinite
        draft.isDarkBackground = action.payload.isDarkBackground
        draft.bulkToast = action.payload.bulkToast
        return draft
      }
      case SET_HIDE_TOAST: {
        draft.hiddenToasts = [
          ...draft.hiddenToasts,
          action.payload.hidableToastName,
        ]
        return draft
      }
      case SET_UNHIDE_TOAST: {
        draft.hiddenToasts = draft.hiddenToasts.filter(
          (hiddenToast) => hiddenToast !== action.payload.hidableToastName,
        )
        return draft
      }
    }
  })
}

export type ToastState = ToastBaseState

export const initialState: ToastState = {
  ...initialBaseState,
}

export type Actions = BaseActions

export default ToastReducer
